/**
 * 能力上下文 Provider（只导出组件，满足 react-refresh 的单一职责要求）。
 */
import type { ReactNode } from 'react';

import { useCapability } from '../platform/useCapability';

import { CapabilityContext } from './capabilityContext';

export function CapabilityProvider({ children }: { children: ReactNode }) {
  const value = useCapability();
  return <CapabilityContext.Provider value={value}>{children}</CapabilityContext.Provider>;
}
